import { phoneReg, telephoneReg } from '@/modules/mdm/utils/regList.js';
export const tableConfig = {
    selection: true,
    height: 357,
    columns: [
        // {
        //     label: '操作',
        //     prop: 'updateType',
        //     type: 'select',
        //     optionsKey: 'MODIFY_RECORD_UPDATE_TYPE',
        //     headerType: 'select',
        //     params: {
        //         params: {
        //             optionsKey: 'MODIFY_RECORD_UPDATE_TYPE'

        //         }
        //     }
        // },
        {
            label: '客户编码',
            prop: 'customerCode',
            mustFill: true,
            width: 100
        },
        {
            label: '姓名',
            prop: 'contactName',
            type: 'input',
            mustFill: true,
            width: 120
        },
        {
            label: '部门',
            prop: 'depart',
            type: 'input',
            width: 120

        },
        {
            label: '职务',
            prop: 'post',
            type: 'input',
            mustFill: true,
            width: 100
        },
        {
            label: '性别',
            prop: 'sex',
            type: 'select',
            options: {
                1: '男',
                2: '女'
            },
            mustFill: true,
            width: 100
        },
        {
            label: '是否默认联系人',
            prop: 'isDefault',
            type: 'select',
            width: 120,
            options: {
                0: '否',
                1: '是'
            },
            mustFill: true
        },
        {
            label: '手机',
            prop: 'mobile',
            slot: true,
            type: 'input',
            mustFill: true,
            verify: phoneReg,
            width: 140,
            className: 'bigData-btn-customer-detail-mobile'
        },
        {
            label: '电话',
            prop: 'tel',
            slot: true,
            type: 'input',
            verify: telephoneReg,
            errorMsg: '只允许输入数字、()、',
            width: 140,
            className: 'bigData-btn-customer-detail-tel'
        },
        {
            label: '联系地址',
            prop: 'contactAddress',
            type: 'input',
            slot: true,
            mustFill: true,
            width: 160,
            className: 'bigData-btn-customer-detail-contactAddress'
        },
        {
            label: '传真',
            prop: 'fax',
            type: 'input',
            slot: true,
            width: 100,
            className: 'bigData-btn-customer-detail-fax'
        },
        {
            label: '邮箱',
            prop: 'email',
            type: 'input',
            slot: true,
            width: 140,
            className: 'bigData-btn-customer-detail-email'
        },
        {
            label: '对我司态度',
            prop: 'attitude',
            type: 'select',
            optionsKey: 'NEOCRM_CUSTOMER_ATTITUDE',
            width: 100
        },
        {
            label: '联系人角色',
            prop: 'contactRole',
            type: 'select',
            optionsKey: 'NEOCRM_CUSTOMER_CONTACT_ROLE',
            width: 100
        },

        {
            label: '备注',
            prop: 'remark',
            type: 'input',
            width: 200
        },
        {
            label: '所有人美信号',
            prop: 'ownerCode',
            width: 100
        },
        {
            label: '所有人姓名',
            prop: 'ownerName',
            width: 100
        },
        {
            label: '所属部门编码',
            prop: 'departmentCode',
            width: 100
        },
        {
            label: '所属部门名称',
            prop: 'departmentName',
            width: 100
        }
    ]
};
